module.exports = __webpack_public_path__ + "assets/images/04-full_608bd998eb4a502d46032fbd8b016ebf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/04-full.png
// module id = 163
// module chunks = 0